// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  forceRedirectToHTTPS: true,
  enableDebug: true,
  apiUrl: 'https://w4ua.sitefpo.com',
  s3Bucket: 'https://w4u.sitefpo.com',
  anonymous3Bucket: 'http://publicw4s.sitefpo.com',
  adminUrl: '/admin',
  pageTitle: {
    prefix: "",
    suffix: "Weave Accreditation Staging",
    separator: " ⁃ "
  },
  pendoApiKey: "cf21a014-f252-49c6-a85f-d688adcd7c61",
  firepadConfig: {
    apiKey: "AIzaSyBHfp_S6ts9xCG_A6xx-EIh__AWor_Ez0Y",
    authDomain: "staging-weave-3.firebaseapp.com",
    databaseURL: "https://staging-weave-3.firebaseio.com/",
    storageBucket: "",
  },
  google_client_id: "564364033451-3ech0rgr6k52po2k28941l5pqk1p6rv1.apps.googleusercontent.com",
  /**
   * Backwards Compatibility
   */
  protocolIncludeASP: false,
  baseUrl: String(),
  googleMapsAPIKey: "AIzaSyDL51CBGH0SIobRMO1T99wBy7EaRag3mNc",
  ccClinetAPIKey: "f88b227f-9e93-47eb-a580-00da9cdfa37c", //constant contact API Key (Client Id)
  stripe_publishable_key: "pk_test_51RIwwR05mHDdoZzRXoyLKeIRdSYdDW5DCwhz8B2nWLo7McJ6lAoLI3X9R9kvJQYI18PMRfNqYJSOMXo5G4HQ5PaE00Hlwkjios",
  hocuspocusWsUrl: 'wss://hocuspocus-staging.weaveaccreditation.com',
  hocuspocusApiUrl: 'https://hocuspocus-staging.weaveaccreditation.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
